import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { PlatformUserActivationLinkService } from '../../../api/api-services/platform-user-activation-link.service';
import { IPlatformUserAccountVm } from '../../../api/platform-user-account-vm.model';

export interface ActivationLinkContext {
  /** Key of the p-confirmDialog that asks before sending. */
  confirmationKey: string;
  /** Guids of the accounts whose link is being sent, for the spinner. */
  pending: Set<string>;
  subscriptions: Subscription;
  confirmationService: ConfirmationService;
  messageService: MessageService;
  activationLinkService: PlatformUserActivationLinkService;
}

/**
 * "Wyślij link aktywacyjny ponownie" of the users list and of the user details: asks first, sends the link and
 * reports the result. A 409 means the account was activated in the meantime, so it is shown as active.
 */
export function confirmAndResendActivationLink(user: IPlatformUserAccountVm, context: ActivationLinkContext): void {
  context.confirmationService.confirm({
    key: context.confirmationKey,
    header: 'Link aktywacyjny',
    message: `Wysłać ponownie link aktywacyjny na adres ${user.email}? Konto zostanie aktywowane, gdy użytkownik kliknie link w wiadomości.`,
    acceptLabel: 'Wyślij',
    rejectLabel: 'Anuluj',
    accept: () => {
      context.pending.add(user.guid);
      context.subscriptions.add(context.activationLinkService.post({ userGuid: user.guid }).subscribe({
        next: result => {
          context.pending.delete(user.guid);
          context.messageService.add({ severity: 'success', summary: 'Link aktywacyjny wysłany',
            detail: `Wysłano na adres ${result.email}.` +
              (result.setsPassword ? ' Konto założono bez hasła, więc użytkownik ustawi je przy aktywacji.' : '') });
        },
        error: (error: HttpErrorResponse) => {
          context.pending.delete(user.guid);
          if (error.status === 409) {
            user.emailConfirmed = true;
            context.messageService.add({ severity: 'info', summary: 'Konto jest już aktywne',
              detail: `${user.email} może się zalogować.` });
            return;
          }
          context.messageService.add({ severity: 'error', summary: 'Nie udało się wysłać linku',
            detail: error.error?.message || 'Spróbuj ponownie za chwilę.' });
        },
      }));
    },
  });
}
